"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrCreateAssociatedTokenAccounts = exports.getAssociatedTokenAddress = void 0;
var tslib_1 = require("tslib");
var common_1 = require("@project-serum/common");
var spl_token_1 = require("@solana/spl-token");
var web3_js_1 = require("@solana/web3.js");
var miscUtils_1 = require("../../src/miscUtils");
var getAssociatedTokenAddress = function (mint, owner, allowOffCurve) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, mint, owner, allowOffCurve)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.getAssociatedTokenAddress = getAssociatedTokenAddress;
var getOrCreateAssociatedTokenAccounts = function (provider, _a) {
    var accountParams = _a.accountParams, signers = _a.signers;
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var addresses, tx, _i, accountParams_1, _b, mint, owner, payer, address, e_1;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    addresses = [];
                    tx = new web3_js_1.Transaction();
                    _i = 0, accountParams_1 = accountParams;
                    _c.label = 1;
                case 1:
                    if (!(_i < accountParams_1.length)) return [3 /*break*/, 7];
                    _b = accountParams_1[_i], mint = _b.mint, owner = _b.owner, payer = _b.payer;
                    return [4 /*yield*/, (0, exports.getAssociatedTokenAddress)(mint, owner)];
                case 2:
                    address = _c.sent();
                    addresses.push(address);
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, (0, common_1.getTokenAccount)((0, miscUtils_1.anchorProviderToSerumProvider)(provider), address)];
                case 4:
                    _c.sent();
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _c.sent();
                    if (e_1 instanceof Error &&
                        e_1.message.match(/Failed to find token account/)) {
                        tx.add(spl_token_1.Token.createAssociatedTokenAccountInstruction(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, mint, address, owner, payer || owner));
                    }
                    else {
                        throw e_1;
                    }
                    return [3 /*break*/, 6];
                case 6:
                    _i++;
                    return [3 /*break*/, 1];
                case 7:
                    if (!tx.instructions.length) return [3 /*break*/, 9];
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return [4 /*yield*/, provider.sendAndConfirm(tx, signers)];
                case 8:
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    _c.sent();
                    _c.label = 9;
                case 9: return [2 /*return*/, addresses];
            }
        });
    });
};
exports.getOrCreateAssociatedTokenAccounts = getOrCreateAssociatedTokenAccounts;
